import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnlocked2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconUnlocked2"><Path fillRule="evenodd" clipRule="evenodd" d="M12 1.5C14.0999 1.5 15.8948 2.79445 16.6357 4.625L14.7822 5.375C14.3364 4.27383 13.2574 3.5 12 3.5C10.3431 3.5 9 4.84315 9 6.5V7.08301C9.92657 6.70786 10.9389 6.5 12 6.5C16.4183 6.5 20 10.0817 20 14.5C20 18.9183 16.4183 22.5 12 22.5C7.58172 22.5 4 18.9183 4 14.5C4 11.9701 5.1755 9.71597 7.00879 8.25H7V6.5C7 3.73858 9.23858 1.5 12 1.5ZM11 17H13V12.25H11V17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUnlocked2;
